import { gql } from '@apollo/client';

export default gql`
  mutation ReportThreadAnswer(
    $courseId: String!
    $threadId: String!
    $answerId: String!
    $input: ReportThreadInput!
  ) {
    reportThreadAnswer(
      courseId: $courseId
      threadId: $threadId
      answerId: $answerId
      input: $input
    )
      @rest(
        type: "Answer"
        path: "courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}/report"
        method: "POST"
      ) {
      NoResponse
    }
  }
`;
